/* 🤖 this file was generated by svg-to-ts */
export const kzIconsUserX: {
  name: 'user_x';
  data: string;
} = {
  name: 'user_x',
  data: `<svg fill="none" viewBox="0 0 16 16"><g clip-path="url(#user-x_svg__a)" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M10.666 14v-1.333A2.667 2.667 0 0 0 7.999 10H3.333a2.667 2.667 0 0 0-2.667 2.667V14M5.667 7.333a2.667 2.667 0 1 0 0-5.333 2.667 2.667 0 0 0 0 5.333ZM12 5.332l3.333 3.333M15.333 5.332 12 8.665"/></g><defs><clipPath id="user-x_svg__a"><path fill="#fff" d="M0 0h16v16H0z"/></clipPath></defs></svg>`
};
